<template>
  <div class="icon-container" @click="handleClick">
    <span class="material-icons" :style="{ fontSize: iconSize }">{{ iconName }}</span>
    <span class="tooltip">{{ tooltipText }}</span>
  </div>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      required: true
    },
    tooltipText: {
      type: String,
      required: true
    },
    iconSize: {
      type: String,
      default: '5em'
    }
  },

  methods: {
    handleClick(event) {
      event.stopPropagation()
      this.$emit('icon-click')
    }
  }
};
</script>

<style scoped>
.tooltip {
  visibility: hidden;
  background-color: #9e9c9c;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 80%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
  min-width: 120px;
  overflow: visible;
  white-space: nowrap;
}
.icon-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.icon-container {
  position: relative;
  display: inline-block;
}
</style>
